class AccountSettings.WorkCalendarSettingView extends Backbone.View
  template: JST["backbone/templates/account_settings/work_calendar"]

  initialize: (options) ->
    @holidays = new AccountSettings.WorkCalendarHolidayCollection()
    @weekdays = new AccountSettings.WorkCalendarWeekdayCollection()
    @fetchAndRender()
    @listenTo @holidays, 'saveError', (errors) =>
      _.each errors, (error) -> showError error
      @fetchAndRender()
    @listenTo @weekdays, 'saveError', (errors) =>
      _.each errors, (error) -> showError error
      @fetchAndRender()
    @listenTo @holidays, 'saveSuccess', -> showSuccess 'Updated holidays'
    @listenTo @weekdays, 'saveSuccess', -> showSuccess 'Updated weekdays'
    super

  fetchAndRender: =>
    @holidays.fetch().done () =>
      @render()
    @weekdays.fetch().done () =>
      weekday_names = @weekdays.map (weekday) -> weekday.get('name')
      lacking_names = _.difference(
        ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
        weekday_names
      )
      @weekdays.add _.map(lacking_names, (name) -> {name: name})
      @render()

  buildTimeZoneSelector: =>
    new Monitoring.Views.TimeZoneSelectorView(
      (@weekdays.first() || @holidays.first())?.get('timezone')
    )

  render: =>
    @$el.html @template { @weekdays, @holidays }
    @initializeTimePickers()
    @timeZoneSelectorView = @buildTimeZoneSelector()
    @$el.find('#work-calendar-time-zone-selector').html(
      @timeZoneSelectorView.render().el
    )
    @$el.find('#weekdays input').on 'change', (event) =>
      $target = $(event.target)
      @weekdays.get($target.attr('id')).set($target.attr('name'), $target.val())
    @$el.find('#holidays input').on 'change', (event) =>
      $target = $(event.target)
      @holidays.get($target.attr('id')).set($target.attr('name'), $target.val())
    @$el.find('#weekdays .checkbox').on 'click', (event) =>
      $target = $(event.target).toggleClass('selected')
      @weekdays.get($target.attr('id')).set($target.data('attribute'), $target.hasClass('selected'))
    @$el.find('#holidays .checkbox').on 'click', (event) =>
      $target = $(event.target).toggleClass('selected')
      @holidays.get($target.attr('id')).set($target.data('attribute'), $target.hasClass('selected'))
    @$el.find('#add-holiday').on 'click', =>
      @holidays.add {}
      @render()
    @$el.find('.delete .icon').on 'click', (event) =>
      $target = $(event.target).closest('.delete')
      @holidays.remove($target.attr('id'))
      $target.parent().remove()
    @$el.find('#update-work-calendar-settings').on('click', @submit)
    @

  initializeTimePickers: =>
    @$el.find('.timepicker').each ->
      $(this).modifiedwickedpicker
        twentyFour: true
        now: $(this).val() || '00:00'
        class: 'work-calendar-picker'
    @$el.find('.datepicker').each ->
      value = $(this).val()
      $(this).datepicker
        autoclose: true
        format: 'dd/mm/yyyy'
      $(this).datepicker 'setDate', value

  submit: =>
    timezone = @timeZoneSelectorView.getSelectedTimeZone()
    for collection in [@holidays, @weekdays]
      collection.each (model) -> model.set timezone: timezone
      collection.save()
